import { Branding } from '../../../models/Branding';

export const GET_BRANDING = 'GET_BRANDING';
export const GENERATE_BRANDING_ERROR = 'GENERATE_ERROR';

export interface GetBrandingAction {
    type: typeof GET_BRANDING;
    payload: InstanceType<typeof Branding>;
}
export interface GenerateBrandingErrorAction {
    type: typeof GENERATE_BRANDING_ERROR;
    error: Error;
}

export type BrandingActionTypes = GetBrandingAction | GenerateBrandingErrorAction;
